<template>
  <div>
    <div class="mb-2">
      <badge :type="document.type === 'stock' ? 'success' : 'primary'" class="mr-2">
        {{ document.type }}
      </badge>
      <p class="d-inline-block">{{ document.date | date('DD/MM/YYYY HH:mm') }}</p>
    </div>

    <div>
      <p class="h5">Usuario</p>
      <p>{{ document.user.name }}</p>
    </div>

    <div>
      <p class="h5">Asignado a</p>
      <router-link
        v-if="$can('show', 'producers')"
        :to="{ name: getDocumentableRoute(document.documentableType), params: { id: document.documentableId } }"
      >
        <p>{{ document.documentable.name }}</p>
      </router-link>
      <p v-else>{{ document.documentable.name }}</p>
    </div>

    <div>
      <p class="h5">Tipo de Individuo</p>
      <p>{{ document.entity }}</p>
    </div>

    <div>
      <p class="h5">Descripción</p>
      <p>{{ document.description }}</p>
    </div>

    <div>
      <a :href="document.path" class="btn btn-outline-black btn-sm" target="_blank">
        <i class="fas fa-download"></i> Descargar archivo
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    document: Object,
  },

  methods: {
    getDocumentableRoute(documentableType) {
      return documentableType == 'producers' ? 'ProducerShow' : 'DistributorShow';
    },
  },
};
</script>
